const addCrossSellProductInCart = () => {
	$('.js-product-cart-add').on('click', function(event) {
		const $masterSelect = $('.js-product-cart-master-select');

		$.ajax({
			url: '/cart/add',
			type: 'POST',
			data: { id: $masterSelect.val() },
		}).done(function() {
			location.reload();
		});

		event.preventDefault();
	});
}

addCrossSellProductInCart();
